export default __webpack_public_path__ + "images/sweep3.a90ccc78204bcd1da04f0bb70686fff1.gif";